<script lang="ts">
	import { dbgIsIdle, dbgIsRunning, dbgStart, dbgResume, dbgPause, dbgState, dbgStop, dbgStepIn, dbgModePausing, resetDebugError } from '../../game/debugger';
	import type { World } from '../../game/World';
	import CodeEditor from './CodeEditor.svelte';
	import Icon from '../elements/Icon.svelte';

	export let world: World;
	export let locked: boolean;

	function ensureRunning( method: () => void ): () => void {
		return () => $dbgIsIdle ? dbgStart( world, method !== dbgResume ) : method();
	}

	function reset(): void {
		resetDebugError();
		world.resetLevel();
	}

	const onRun = ensureRunning( dbgResume );
	const onStepIn = ensureRunning( dbgStepIn );
</script>

<div class="code-area">
	<div class="button-bar">
		{#if $dbgIsRunning }
			<!-- Pause Button -->
			<button on:click={ dbgPause } disabled={ $dbgModePausing || locked }>
				{#if $dbgModePausing }
					Pausing...
				{:else}
					<Icon i="pause"/> Pause
				{/if}
			</button>
		{:else}
			<!-- Play Button -->
			<button on:click={ onRun } disabled={ locked }>
				<Icon i="play"/> Run
			</button>
		{/if}

		<!-- Step Button -->
		<button on:click={ onStepIn } disabled={ $dbgIsRunning || locked }>
			<Icon i="step-forward" /> Step
		</button>

		{#if ! $dbgIsIdle }
			<!-- Stop Button -->
			<button on:click={ dbgStop } disabled={ locked }>
				<Icon i="stop" /> Stop
			</button>
		{:else}
			<!-- Reset Button -->
			<button on:click={ reset } disabled={ locked || world.getStep() === 0 }>
				<Icon i="undo" /> Reset
			</button>
		{/if}
	</div>

	<CodeEditor
		bind:value={ world.code }
		disabled={ ! $dbgIsIdle || locked }
		on:reset={ dbgStop }
		{ world }
	/>
</div>

<style>
	.code-area {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		background-color: #011e3a;
		position: relative;
	}

	.button-bar {
		padding: 10px 20px 10px 50px;
	}

	button {
		margin-right: 4px;
		width: 80px;
	}

	.code-area {
		flex-grow: 1;
	}
</style>